import React from "react";
import images from "../assets/images.tsx";

const Alert = (props) => {

    function GetImage() {
        const image = props.image;

        if (image === "success") {
            return images.check;
        }
        if (image === "warning") {
            return images.exclamation_triangle;
        }

        return null;
    }

    return (
        <div className={`mt-3 alert ${props.className}`} role="alert">
            <div className="row">
                <div className="col-2 alert-svg">
                    <img src={GetImage()} width="42" height="32" alt="" />
                </div>
                <div className="col-10 avertical-align">
                    <div className="alerta">{props.message}</div>
                </div>
            </div>
        </div>
    )
}

export default Alert;